import { getRequest, postRequest, putRequest, deleteRequest } from "./api.request";

const ROLE_PATH = "/apis/role/v1";

// Get all roles
export const getRolesApi = async () => await getRequest(ROLE_PATH);

// Get role by ID
export const getRoleByIdApi = async (id) => await getRequest(`${ROLE_PATH}/${id}`);

// Add new role
export const addRoleApi = async (data) => await postRequest(ROLE_PATH, data);

// Update role permissions
export const updateRoleApi = async (id, data) => await putRequest(`${ROLE_PATH}/${id}`, data);

// Delete role
export const deleteRoleApi = async (id) => await deleteRequest(`${ROLE_PATH}/${id}`); 